import React, { useState } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import ComboBox from '../../../Components/ComboBox'
import FileUploadIcon from '@mui/icons-material/FileUpload'

import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'

import { styled } from '@mui/material/styles'
import { Box, Stack } from '@mui/material'

const Input = styled('input')({
  display: 'none',
})

export default function UploadOperations() {
  const [open, setOpen] = useState(false)
  const [accounts, setAccounts] = useState([])
  const [numeroCompte, setNumeroCompte] = useState(null)
  const [file, setFile] = useState(null)

  const fetchAccounts = async () => {
    setNumeroCompte(null)
    setFile(null)
    const { data, status } = await makeGetRequest(urls.fetchAccounts + '?limit=1000000', {}, true)
    if (status === 200) {
      const filterAccounts = []
      data.forEach((v) => {
        filterAccounts.push({ label: `${v.NumeroCompte}`, id: v.id })
      })
      setAccounts([...filterAccounts])
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
    fetchAccounts()
  }

  const handleClose = () => {
    setOpen(false)
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    if (numeroCompte === null || numeroCompte === '' || file === '' || file === null) {
      alert('Please Select Nom Compte')
    } else {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('NumeroCompte', numeroCompte)
      const response = await makePostRequest(urls.addBulkOperations, formData, {}, true)
      if (response.status === 201 || response.status === 200) {
        handleClose()
      }
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>Importer donnée</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle>Import Opérations</DialogTitle>
        <form onSubmit={onSubmit}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => setNumeroCompte(j.id)}
              label="Nom Compte"
              data={accounts}
              name="NumeroCompte"
            />
            <label htmlFor="contained-button-file2">
              <Input
                accept="/*"
                id="contained-button-file2"
                onChange={(e) => setFile(e.target.files[0])}
                type="file"
              />
              <Stack mt={2} justifyContent="center" width={'100%'}>
                <Button variant="outlined" component="span" startIcon={<FileUploadIcon />}>
                  Upload CSV2
                </Button>
              </Stack>
            </label>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
